<template>
    <div class="logo">
        <h1 class="text-center mb-5">Trocando de ambiente...</h1>
    </div>
</template>

<script>
  import editarVendasMixin from '@/mixins/editarVendasMixin'
  import { loadFlavor } from '../plugins/flavors'
  import { Flavors } from '../plugins/constants'
  import { alert, existHierarchy } from '@/plugins/helpers'
  import { setarDadosDaSessao } from '../webservice/autenticar'
  export default {
    name: 'TrocaAmbiente',
    mixins: [editarVendasMixin],
    data: () => ({
      conteudo_cryptografado: null,
      conteudo_descryptografado: null,
      id_pedido: null
    }),
    async mounted () {
      try {
        this.$session.destroy()

        this.getFlavorsEEmpresas().then(r => {
          this.getAdministradoras().then(r => {
            const params = this.$route.query
            loadFlavor(params.flavor)
            this.id_pedido = params.id_pedido
            this.$http.post('/descryptografar/excluindo/com_chave', {
              chave: this.id_pedido
            }).then(res => {
              this.conteudo_descryptografado = res.data
              setarDadosDaSessao(this.conteudo_descryptografado)
              this.setarDadosSessao(this.conteudo_descryptografado, +params.id_empresa, params.flavor)
              this.loadConfiguracoes()
              this.$http.get(`/pedido/${this.id_pedido}`).then((res) => {
                this.editar(res.data, true)
              }).catch(() => {
                this.showErrorAndLogout()
              })
            }).catch(() => {
              this.showErrorAndLogout()
            })
          }).catch(() => {
            this.showErrorAndLogout()
          })
        }).catch(() => {
          this.showErrorAndLogout()
        })
      } catch {
        this.showErrorAndLogout()
      }
    },
    methods: {
      showErrorAndLogout () {
        alert({
          text: `Falha ao autenticar.\nTente novamente.`,
          buttons: {
            'Ok': () => this.$router.replace({ name: 'logout' })
          }
        })
      },
      loadConfiguracoes () {
        this.$http.get('/usuarios/configuracoes', { options: { silent: true } })
          .then(res => {
            this.$session.set('configuracoes', res.data)
          })
      },
      setarDadosSessao (dadosSessao, id_empresa, flavor) {
        const chaveDosDadosDaSessao = Object.keys(dadosSessao)
        chaveDosDadosDaSessao.forEach(chave => {
          this.$session.set(chave, dadosSessao[chave])
        })
        this.$session.set('trocando_ambiente', true)
        this.$session.set('id_empresa', id_empresa)
        if (existHierarchy(this.$session.get('hierarquia_comercial'))) {
          this.$session.set('flavor', Flavors.ED)
        } else {
          this.$session.set('flavor', flavor)
        }
      }

    }
  }
</script>

<style lang="scss" scoped>
.logo {
  width: 100%;
  margin-top: 15px;
}

.logo img {
  margin: auto;
  display: block;
}
</style>
